/* eslint-disable functional/no-conditional-statement */
import { useEffect } from "react";
import { Toasts } from "../../common/components/Toasts";
import { useInitializeCartState } from "../hooks/useInitializeCartState";
import { useSetHtmlFromSettings } from "../hooks/useSetHtmlFromSettings";
import { useSettingsValueData } from "../hooks/useSettingsValueData";
import "../styles/is-loading-span.scss";
import { AppErrors } from "./AppErrors";
import { AppRoutes } from "./AppRoutes";
import { BreadCrumbs } from "../../common/components/BreadCrumbs";
import { Container } from "./Container";
import { LoaderProviderA } from "./LoaderProviderA";
import { setToken } from "../../sign-in/miscellaneous/setToken";
import { parseCookie } from "../../payment/miscellaneous/parseCookie";

export function App() {
  const cartLoader = useInitializeCartState();
  const settings = useSettingsValueData();

  const isUserType =
    settings.tag === "ready" &&
    settings.data &&
    settings.data.authTypes?.toLocaleLowerCase() === "user";

  const isCartLoading =
    cartLoader.tag === "initial" || cartLoader.tag === "loading";

  useSetHtmlFromSettings(settings);

  useEffect(() => {
    if (isUserType && !parseCookie(document.cookie)["MkHcLoggedInToken"]) {
      setToken("login-requested");
    }
  }, [settings.data && settings.data.authTypes]);

  return isCartLoading ? null : (
    <>
      <BreadCrumbs />
      <Container>
        <LoaderProviderA loader={cartLoader} glow={true}>
          <AppErrors />

          <AppRoutes />

          <Toasts />
        </LoaderProviderA>
      </Container>
    </>
  );
}
